export default class logger {
    constructor() {
        layer.config({
            skin: 'ysy-layer',
        })
    }

    logSuccess(message, manuClose) {
        /** 成功提示组件
        *   message: <String> 必填 提示内容
        *   manuClose： <Boolean> 是否可以手动关闭
        * */
        if (message == null) return
        let time = 3000
        let offset = '42px'
        let width = '174px'
        const iconHtml = '<div class="icon-left"><i class="icon iconfont icon-shouqicopy iconfont-success"></i></div>'
        let closeHtml = ''
        let contentHtml = ''
        if (manuClose && typeof manuClose === 'boolean') {
            time = 10000
            offset = '30px'
            width = '228px'
            closeHtml = '<div class="icon-right j-closebtn"><i class="icon iconfont icon-shanchu3"></i></div>'
        }
        contentHtml = `<div class="layer-tips-content">
            ${iconHtml}
            <div class="content-center">${message}</div>
            ${closeHtml}
        </div>`
        const msg = layer.open({
            type: 0,
            title: false,
            shade: false,
            anim: 1,
            resize: false,
            closeBtn: 0,
            btn: false,
            shadeClose: false,
            skin: 'layer-tips-self',
            // area: width,
            offset,
            time,
            content: `${contentHtml}`,
            success(layero, index) {
                $(layero).find('.j-closebtn').on('click', () => {
                    layer.close(index)
                })
            },
        })
    }

    logError(message, manuClose) {
        /** 失败提示组件
        *   message: <String> 必填 提示内容
        *   manuClose： <Boolean> 是否可以手动关闭
        * */
        if (!message) return
        let time = message.length * 300
        time = time > 8000 ? 8000 : time
        time = time < 3000 ? 3000 : time
        let offset = '42px'
        const iconHtml = '<div class="icon-left"><i class="icon iconfont icon-shanchu iconfont-error"></i></div>'
        let closeHtml = ''
        let contentHtml = ''
        if (manuClose && typeof manuClose === 'boolean') {
            time = 10000
            offset = '30px'
            closeHtml = '<div class="icon-right j-closebtn"><i class="icon iconfont icon-shanchu3"></i></div>'
        }
        contentHtml = `<div class="layer-tips-content">
            ${iconHtml}
            <div class="content-center">${message}</div>
            ${closeHtml}
        </div>`
        const msg = layer.open({
            type: 0,
            title: false,
            shade: false,
            anim: 1,
            resize: false,
            closeBtn: 0,
            btn: false,
            shadeClose: false,
            skin: 'layer-tips-self',
            // area: width,
            offset,
            time,
            content: `${contentHtml}`,
            success(layero, index) {
                $(layero).find('.j-closebtn').on('click', () => {
                    layer.close(index)
                })
            },
        })
    }

    logTips(message, icon, manuClose) {
        /** 提示组件
        *   message: <String> 必填 提示内容
        *   icon： <String> 提示图标类型 目前有'tishi', 'success', 'warn', 'error'
        *   manuClose： <Boolean> 是否可以手动关闭
        * */
        if (message == null) return
        let time = 3000
        let offset = '42px'
        let width = '174px'
        let iconHtml = ''
        let closeHtml = ''
        let contentHtml = ''
        if (manuClose && typeof manuClose === 'boolean') {
            time = 10000
            offset = '30px'
            width = '228px'
            closeHtml = '<div class="icon-right j-closebtn"><i class="icon iconfont icon-shanchu3"></i></div>'
        }
        if (icon && typeof icon === 'string') {
            iconHtml = `<div class="icon-left"><i class="icon iconfont icon-${icon} iconfont-${icon}"></i></div>`
        }
        contentHtml = `<div class="layer-tips-content">
            ${iconHtml}
            <div class="content-center">${message}</div>
            ${closeHtml}
        </div>`
        layer.open({
            type: 0,
            title: false,
            shade: false,
            anim: 1,
            resize: false,
            closeBtn: 0,
            btn: false,
            shadeClose: false,
            skin: 'layer-tips-self',
            // area: width,
            offset,
            time,
            content: `${contentHtml}`,
            success(layero, index) {
                $(layero).find('.j-closebtn').on('click', () => {
                    layer.close(index)
                })
            },
        })
    }

    logMsg(options) {
        /** 提示组件
        *   options: <Object> 参数
        *   <Object> Options 参数明细
        *       message: <String> 必填 提示内容
        *       title: <String> 标题
        *       icon： <String> 提示图标类型 目前有'tishi', 'success', 'warn', 'error'
        * */
        if (options === undefined || options === null || typeof options !== 'object') return
        if (options.message == null) return
        const _opt = {
            btn: ['确定'],
        }
        const opt = $.extend(true, _opt, options)
        let titleHtml = ''
        let iconHtml = ''
        let contentHtml = ''
        // 是否有标题
        if (opt.title && typeof opt.title === 'string') {
            titleHtml = `<div class="message-title">${opt.title}</div>`
        }
        // 是否有icon
        if (opt.icon && typeof opt.icon === 'string') {
            iconHtml = `<div class="content-left"><i class="icon iconfont icon-${opt.icon} iconfont-${opt.icon}"></i></div>`
        }
        contentHtml = `<div class="layer-msg-content">
                ${iconHtml}
                <div class="content-center">
                    ${titleHtml}
                    <div class="message-content">${opt.message}</div>
                </div>
            </div>`
        console.log(opt.btn)
        layer.open({
            type: 0,
            title: false,
            resize: false,
            closeBtn: 0,
            btn: opt.btn,
            shadeClose: false,
            skin: 'layer-message-self',
            content: `${contentHtml}`,
            yes(index, layero) {
                // 按钮【按钮一】的回调
                if (opt.btn.length === 1) {
                    layer.close(index)
                }
                if (opt.yes && typeof opt.yes === 'function') {
                    opt.yes(index)
                }
            },
            btn2(index, layero) {
                // 按钮【按钮二】的回调
                // return false 开启该代码可禁止点击该按钮关闭
                // layer.close(index)
                if (opt.btn2 && typeof opt.btn2 === 'function') {
                    opt.btn2(index)
                }
            },
        })
    }
}



// WEBPACK FOOTER //
// ./src/common/services/loggerService.js